<script lang="ts" setup>
import { MetricType, calculateDeltaValue, calculateMetricValue, Type, getLabel } from './../utility';
import { MeasureResult } from '@Shared/utils/types';

import GreyDownArrowSvg from '../visualAssets/GreyDownArrow.svg?component';
import GreyUpArrowSvg from '../visualAssets/GreyUpArrow.svg?component';
import GreyLevelArrowSvg from '../visualAssets/GreyLevelArrow.svg?component';
import { DeltaType } from './../utility';

import NpsPromoter from '../visualAssets/NpsPromoter.svg?component';
import NpsNeutral from '../visualAssets/NpsNeutral.svg?component';
import NpsDetractor from '../visualAssets/NpsDetractor.svg?component';

import { FunctionalComponent } from 'vue';

const props = defineProps<{
  value: MeasureResult;
  type: Type;
  metricType?: MetricType;
  inPopup?: boolean;
}>();

function getDeltaSvg(measureResult: MeasureResult) {
  if (props.value == null) return null;
  const deltaValue = calculateDeltaValue(measureResult, DeltaType.ResponseDelta) ?? 0;

  if (deltaValue > 0) return GreyUpArrowSvg;
  if (deltaValue < 0) return GreyDownArrowSvg;
  return GreyLevelArrowSvg;
}

const labels = computed(() => getLabel(props.metricType));

const images: Record<Type, FunctionalComponent | null> = {
  Positive: NpsPromoter,
  Neutral: NpsNeutral,
  Negative: NpsDetractor,
  Null: null,
};
</script>
<template>
  <div class="flex flex-col" v-if="inPopup">
    <div class="uppercase grid-row[1-1] font-family[Roboto] sm:text-3 xs:text-4">
      {{ labels[type] }}
    </div>
    <div class="flex flex-row">
      <div class="sm:text-4 xl:text-4 font-bold xs:text-6 md:text-6 h-full">
        {{ calculateMetricValue(value.currentValue, MetricType.Count) }}
      </div>
      <div class="pl-1 sm:text-3 xl:text-3 font-bold xs:text-4 md:text-4 flex flex-row items-center">
        <component class="pr-1 w-[18px] h-[18px]" :is="getDeltaSvg(value)"></component>
        <div>
          {{ calculateDeltaValue(value, DeltaType.ResponseDelta) }}
        </div>
      </div>
    </div>
  </div>
  <component v-if="!inPopup" class="grid-column[1-1] mr-4 w-24px h-24px" :is="images[type]" />
  <div v-if="!inPopup" class="sm:text-4 xl:text-4 font-bold xs:text-6 md:text-6 h-full grid-column[2-2] mr-4">
    {{ calculateMetricValue(value.currentValue, MetricType.Count) }}
  </div>
  <div
    v-if="!inPopup"
    class="sm:text-3 xl:text-3 grid-column[4-4] font-bold xs:text-4 md:text-4 flex flex-row items-center"
  >
    <component class="pr-1 w-[24px] h-[16px]" :is="getDeltaSvg(value)"></component>
    <div>
      {{ calculateDeltaValue(value, DeltaType.ResponseDelta) }}
    </div>
  </div>
</template>
